import { useSearchParams } from 'react-router-dom'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import PlatformActivityPage from '@/modules/platform-activity/page'

const EMBED_TABS = {
  blueprints: {
    label: 'Blueprints Adoption',
    embedUrl:
      'https://app.powerbi.com/reportEmbed?reportId=05cffa6b-8e9a-41f6-878d-468bb1b0316e&autoAuth=true&ctid=33d4f3e5-3df2-421e-b92e-a63cfa680a88'
  },
  'usage-metrics': {
    label: 'Usage Metrics',
    embedUrl:
      'https://app.powerbi.com/reportEmbed?reportId=a15f97e7-56c7-41f6-866e-5c85fff9ecaa&autoAuth=true&ctid=33d4f3e5-3df2-421e-b92e-a63cfa680a88'
  }
}

export const PLATFORM_ACTIVITY_TAB = 'platform-activity'

const TAB_VALUES = [PLATFORM_ACTIVITY_TAB, ...Object.keys(EMBED_TABS)]

// platform activity's own params don't apply to the Power BI embeds
const PLATFORM_ACTIVITY_PARAMS = ['granularity', 'sort', 'order']

const InternalBI = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const activeTab =
    tabParam && TAB_VALUES.includes(tabParam) ? tabParam : PLATFORM_ACTIVITY_TAB

  // push (not replace) so back/forward switches tabs
  const handleTabChange = (value: string) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev)

      PLATFORM_ACTIVITY_PARAMS.forEach((key) => next.delete(key))
      if (value === PLATFORM_ACTIVITY_TAB) next.delete('tab')
      else next.set('tab', value)

      return next
    })
  }

  return (
    <Tabs
      className="w-full h-full flex flex-col"
      onValueChange={handleTabChange}
      value={activeTab}
    >
      <TabsList className="grid w-full grid-cols-3">
        <TabsTrigger value={PLATFORM_ACTIVITY_TAB}>
          Platform Activity
        </TabsTrigger>
        {Object.entries(EMBED_TABS).map(([key, value]) => (
          <TabsTrigger key={key} value={key}>
            {value.label}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value={PLATFORM_ACTIVITY_TAB}>
        <PlatformActivityPage />
      </TabsContent>
      {Object.entries(EMBED_TABS).map(([key, value]) => (
        <TabsContent className="h-full" key={key} value={key}>
          <iframe
            allowFullScreen={true}
            height={'100%'}
            src={value.embedUrl}
            title="epilot Internal BI"
            width={'100%'}
          />
        </TabsContent>
      ))}
    </Tabs>
  )
}

export default InternalBI
